import { captureException } from '@sentry/react';

export class MutationError extends Error {
  public mutationVariables: unknown;

  constructor(message: string, mutationVariables: unknown) {
    super(message);
    this.name = 'MutationError';
    this.mutationVariables = mutationVariables;
  }

  capture() {
    captureException(this, {
      extra: {
        mutationVariables: this.mutationVariables,
      },
      fingerprint: ['MutationError'],
    });
  }
}
